require("datatables.net/js/jquery.dataTables")

$(document).on("init.dt", (e) => {
  const $search = $(e.target).prev().find('input[type="search"]')
  const placeholder = $search.attr("placeholder")

  if ($search.length > 0 && placeholder !== undefined && placeholder !== "") {
    $search.parent().prepend(`<span class="sr-only">${placeholder}</span>`)
  }
})

$.extend($.fn.dataTableExt.oSort, {
  "title-numeric-pre": (a) => {
    return parseFloat(a?.match && a.match(/title="*(-?[0-9.]+)/)[1])
  },
  "title-numeric-asc": (a, b) => {
    return a < b ? -1 : a > b ? 1 : 0
  },
  "title-numeric-desc": (a, b) => {
    return a < b ? 1 : a > b ? -1 : 0
  },
})

$.extend($.fn.dataTableExt.oSort, {
  "title-string-pre": (a) => {
    return a.match(/title="(.*?)"/)[1].toLowerCase()
  },
  "title-string-asc": (a, b) => {
    return a < b ? -1 : a > b ? 1 : 0
  },
  "title-string-desc": (a, b) => {
    return a < b ? 1 : a > b ? -1 : 0
  },
})
